import { IEnumObject, IStandardEnum } from 'types/global/enum.interface';

export const enumToObject = <T = number | string>(
  ENUM: IStandardEnum<T>,
  lastElement?: number
): IEnumObject<T>[] => {
  const enumEntries = Object.entries(ENUM);
  
  return enumEntries
    .slice(
      enumEntries.length -
        (lastElement ? lastElement + 1 : Math.floor(enumEntries.length * 0.5)),
      !lastElement ? enumEntries.length : enumEntries.length - 1
    )
    .map(entry =>
      entry[0] !== '-1'
        ? { key: entry[0], value: entry[1] as T }
        : { key: entry[1] as string, value: entry[0] as T }
    );
};

export const objectToArray = <T extends {}>(object: T) =>
  Object.entries(object).map(entry => ({ key: entry[0], value: entry[1] }));
